module.exports = PropTypes;


//////////////////
// WEBPACK FOOTER
// external "PropTypes"
// module id = 2
// module chunks = 0